import { useAxios } from '@academica-box/composables/axios'
import { DefaultApi } from '@academica-box/swagger/academgen/api'
import type { EdpartnersPostbackRequest } from '@academica-box/swagger/academgen'

export type SendData = EdpartnersPostbackRequest

export default () => {
  const config = useRuntimeConfig()
  const axios = useAxios()
  const defaultApi = new DefaultApi(undefined, `${config.public.academgenApiUrl}/api`, axios)

  return {
    sendData(data: SendData) {
      return defaultApi.edpartnersPostback({ edpartnersPostbackRequest: data })
    }
  }
}
